function onTranscendReady() {
    // check if ready (repeatedly)
    if (!self.transcend || typeof self.transcend.ready !== 'function') {
        const transcendObj = self.transcend || {};
        self.transcend = {
            readyQueue: [],
            ready: function (callback) {
                this.readyQueue.push(callback);
            }
        };

        // copy existing properties
        Object.keys(transcendObj).forEach(key => {
            self.transcend[key] = transcendObj[key];
        });
    }

    // wait for consent prompt to load
    self.transcend.ready(function (transcend) {
        const closedViewStates = ['Hidden', 'Closed', 'Collapsed'];
        let pageScrollPosition = null;

        function captureScrollPosition(e) {
            if (e.target.closest('#transcend-consent-manager')) {
                pageScrollPosition = {
                    x: window.scrollX || window.pageXOffset,
                    y: window.scrollY || window.pageYOffset
                };
            }
        }

        transcend.addEventListener('view-state-change', function (event) {
            const { viewState } = event.detail;
            if (closedViewStates.includes(viewState)) {
                document.removeEventListener('click', captureScrollPosition, true);

                // restore scroll position after DOM updates
                if (pageScrollPosition) {
                    setTimeout(() => {
                        window.scrollTo(pageScrollPosition.x, pageScrollPosition.y);
                        pageScrollPosition = null;
                    }, 0);
                }
            } else {
                document.addEventListener('click', captureScrollPosition, true);
            }
        });
    });
}

// init immediately if loaded, otherwise wait
if (typeof transcend !== 'undefined') {
    onTranscendReady();
} else {
    // called when airgap.js is loaded
    window.onTranscendLoaded = onTranscendReady;
}
